import { type AsyncReturnType } from "type-fest";
import { type AppContext } from "~/lib/context";
import { getRequiredUser } from "~/lib/getRequiredUser";

export const fetchFiltersPresets = async (ctx: AppContext) => {
  const user = getRequiredUser(ctx);

  return ctx.prisma.filtersPreset.findMany({
    where: {
      userId: user.id,
    },
    include: {
      jobs: {
        include: { jobAliases: true },
      },
      customJobs: true,
      comparedJobs: true,
      marketFilters: {
        include: {
          labels: true,
          industries: true,
          industry: true,
          locations: {
            include: { country: true },
          },
        },
      },
    },
  });
};

export type FetchFiltersPresetsResult = AsyncReturnType<typeof fetchFiltersPresets>;
